export enum CreateEditShortLinkType {
  CREATE = 'create',
  EDIT = 'edit',
}
